import React from 'react';

interface LoadingSpinnerProps {
  text: string;
  containerPadding?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  text,
  containerPadding = '40px 20px'
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: containerPadding,
      }}
    >
      <div
        style={{
          fontSize: '16px',
          color: '#007aff',
          marginBottom: '10px',
          fontWeight: '500',
        }}
      >
        {text}
      </div>
      <div
        style={{
          width: '40px',
          height: '40px',
          border: '3px solid #f3f3f3',
          borderTop: '3px solid #007aff',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }}
      ></div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default LoadingSpinner;
